export default __webpack_public_path__ + "KaTeX_Math-Italic.11278d3697e58b20e960ac9ee24ab338.woff";